export const repeatDisordersModule = {
  id: "repeat-disorders",
  title: "Repeat Disorders",
  sections: [
    {
      type: "text",
      content: `<h3>Trinucleotide Repeat Disorders</h3>
      <p>Trinucleotide repeat disorders are a group of genetic disorders caused by the expansion of a specific trinucleotide sequence in the DNA. These repeats can occur in various genes and lead to a range of symptoms depending on the gene affected and the number of repeats.</p>
      <p>Some common trinucleotide repeat disorders include:</p>
      <ul>
        <li><b>Huntington's disease:</b> Caused by <b>CAG</b> repeat expansion in the HTT gene, leading to progressive neurodegeneration.</li>
        <li><b>Fragile X syndrome:</b> Caused by <b>CGG</b> repeat expansion in the FMR1 gene, leading to intellectual disability and developmental delays.</li>
        <li><b>Myotonic dystrophy:</b> Caused by <b>CTG</b> repeat expansion in the DMPK gene, leading to muscle weakness and myotonia.</li>
        <li><b>Friedreich ataxia:</b> Caused by <b>GAA</b> repeat expansion in the FXN gene, leading to progressive ataxia and cardiomyopathy.</li>
      </ul>
      <p>Trinucleotide repeat disorders show <b>anticipation</b>, with increasing repeats in successive generations.</p>`,
    },
    {
      type: "question",
      text: "Which disorder is due to CAG repeat expansion?",
      options: [
        "Huntington disease",
        "Fragile X",
        "Myotonic dystrophy",
        "Friedreich ataxia",
      ],
      correct: 0,
      explanation:
        "Huntington disease is caused by CAG repeat expansion in the HTT gene.",
    },
    {
      type: "text",
      content: `
      <p><b>Anticipation</b> refers to the phenomenon where the severity of the disorder increases and the age of onset decreases in successive generations. This is often observed in trinucleotide repeat disorders due to the unstable nature of the repeat sequences, that tend to expand during each meiosis.
      <ul>Anticipation => symptoms get worse and appear sooner with each generation as the repeats get longer</ul></p>
      <p>Diagnosis of trinucleotide repeat disorders can be done through genetic testing, which involves analyzing the number of repeats in the affected gene. Tests like <b>triplet-primed PCR (TP-PCR)</b> and <b>Southern blotting</b> are commonly used. It is worthy to note that whole exome/genome sequencing are not preferred for repeat analysis as 
      the repetitive nature of the sequence can lead to difficulties in accurate sequencing and analysis.</p>
      </p>
      <p>Treatment options are currently limited and mainly focus on managing symptoms, although research is ongoing to develop targeted therapies.</p>
      
      <div class="highlight-box">
      <p><b>Key points:</b></p>
      <ul>
        <li>Trinucleotide repeat disorders are caused by the expansion of specific trinucleotide sequences in the DNA.</li>
        <li>Common disorders include Huntington's disease, Fragile X syndrome, Myotonic dystrophy, and Friedreich ataxia.</li>
        <li>These disorders show anticipation, with increasing severity in successive generations.</li>
        <li>Diagnosis is through genetic testing, and treatment focuses on symptom management.</li>
      </ul>
      </div>
      `,
    },
  ],
};
